export default "__VITE_ASSET__caa19e22__"